import axios from "axios";
import * as cookies from "vue-cookies";
import * as moment from "moment";
moment.locale("es-mx");

export async function getStores({ commit }, data) {
  try {
    commit("setLoading", true, { root: true });

    const headers = {
      authorization: `Bearer ${cookies.get("token")}`,
    };
    if (!data) {
      data = "/";
    }

    await axios
      .get(`/stores${data}`, { headers })
      .then((response) => {
        const { docs, ...data } = response.data;

        // docs.forEach((item) => {
        //   item.createdAt = moment(item.createdAt).startOf("hour").fromNow();
        // });

        commit("setStores", docs);
        commit("setPagination", data, { root: true });
      })
      .catch((err) => {
        console.log(err.response.data.message);
        commit("setError", err.response.data.message);
      });
  } catch (error) {
    console.log(error);
    commit("setError", err.response);
  } finally {
    commit("setLoading", false, { root: true });
  }
}

export async function getStore({ commit }, id) {
  try {
    commit("setLoading", true, { root: true });

    const headers = {
      authorization: `Bearer ${cookies.get("token")}`,
    };

    await axios
      .get(`/stores/${id}`, { headers })
      .then((response) => {
        const data = response.data;
        data.createdAt = moment(data.createdAt).startOf("date").fromNow();

        commit("setStore", data);
      })
      .catch((err) => {
        console.log(err);
        commit("setError", err.response.data.message);
      });
  } catch (error) {
    console.log(error);
    commit("setError", err.response);
  } finally {
    commit("setLoading", false, { root: true });
  }
}

export async function updateStore({ commit }, data) {
  try {
    commit("setLoading", true, { root: true });

    const headers = {
      authorization: `Bearer ${cookies.get("token")}`,
    };

    await axios
      .put(`/stores/${data._id}`, data, { headers })
      .then((response) => {
        const data = response.data;
        console.log(data);

        data.createdAt = moment(item.createdAt).startOf("day").fromNow();

        commit("setStore", data);
      })
      .catch((err) => {
        console.log(err.response.data.message);
        commit("setError", err.response.data.message);
      });
  } catch (error) {
    console.log(error);
    commit("setError", err.response);
  } finally {
    commit("setLoading", false, { root: true });
  }
}

export async function createStore({ commit }, data) {
  try {
    commit("setLoading", true, { root: true });

    const headers = {
      authorization: `Bearer ${cookies.get("token")}`,
    };

    console.log({ data });

    await axios
      .post(`/stores`, data, { headers })
      .then((response) => {
        const data = response.data;
        console.log(data);

        data.createdAt = moment(item.createdAt).startOf("day").fromNow();

        commit("setStore", data);
        commit("setSuccess", "Almacen creado");
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response);
          commit("setError", err.response);
        }
      });
  } catch (error) {
    console.log(error);
    commit("setError", error.response);
  } finally {
    commit("setLoading", false, { root: true });
  }
}

export async function deleteStore({ commit }, id) {
  try {
    commit("setLoading", true, { root: true });

    const headers = {
      authorization: `Bearer ${cookies.get("token")}`,
    };

    await axios
      .delete(`/stores/${id}`, { headers })
      .then((response) => {
        commit("setSuccess", "eliminado");
      })
      .catch((err) => {
        console.log(err.response.data.message);
        commit("setError", err.response.data.message);
      });
  } catch (error) {
    console.log(error);
    commit("setError", err.response.data.message);
  } finally {
    commit("setLoading", false, { root: true });
  }
}

export async function removeProduct({ commit }, data) {
  try {
    const { _id, ...product } = data;

    commit("setLoading", true, { root: true });

    const headers = {
      authorization: `Bearer ${cookies.get("token")}`,
    };

    await axios
      .delete(`inventories/${_id}`, product, { headers })
      .then((result) => {})
      .catch((err) => {
        console.log(err.response);
        commit("setError", err.response.data.message);
      });
  } catch (error) {
    console.log(error);
  } finally {
    commit("setLoading", false, { root: true });
  }
}
